import { reactive, readonly } from 'vue'
import axios from 'axios'
import apiConfig from '@/config/api.js'

const state = reactive({
  userInfo: null,
  isLoggedIn: false,
  checkInStatus: {
    hasCheckedIn: false,
    consecutiveDays: 0,
    lastCheckInDate: null
  }
})

const mutations = {
  setUserInfo(userInfo) {
    state.userInfo = userInfo
    state.isLoggedIn = true
  },
  logout() {
    state.userInfo = null
    state.isLoggedIn = false
  },
  setCheckInStatus(status) {
    state.checkInStatus = { ...state.checkInStatus, ...status }
  },
  updatePoints(amount) {
    if (state.userInfo) {
      state.userInfo.points = (state.userInfo.points || 0) + amount
    }
  }
}

const actions = {
  async login(phone, password) {
    try {
      const response = await axios.post(apiConfig.member.login, {
        phone: phone,
        pwd: password
      }, {
        params: {
          phone: phone,
          pwd: password
        }
      })
      
      if (response.data.code === 200) {
        const userInfo = response.data.data
        mutations.setUserInfo(userInfo)
        return true
      } else {
        console.error('登录失败:', response.data.message)
        return false
      }
    } catch (error) {
      console.error('登录请求失败:', error)
      return false
    }
  },
  async register(registerForm) {
    try {
      const response = await axios.post(apiConfig.member.register, {
        phone: registerForm.phone,
        email: registerForm.email,
        pwd: registerForm.password,
        nickname: registerForm.nickname
      })
      
      if (response.data.code === 200) {
        return true
      } else {
        console.error('注册失败:', response.data.message)
        return false
      }
    } catch (error) {
      console.error('注册请求失败:', error)
      return false
    }
  },
  logout() {
    mutations.logout()
  },
  async checkIn() {
    if (!state.userInfo) {
      return Promise.reject('用户未登录')
    }
    
    try {
      const response = await axios.post(apiConfig.member.checkIn, {
        memberId: state.userInfo.id
      }, {
        params: {
          memberId: state.userInfo.id
        }
      })
      
      if (response.data.code === 200) {
        const checkInStatus = response.data.data
        mutations.setCheckInStatus(checkInStatus)
        return checkInStatus
      } else {
        console.error('签到失败:', response.data.message)
        return state.checkInStatus
      }
    } catch (error) {
      console.error('签到请求失败:', error)
      return state.checkInStatus
    }
  },
  async getCheckInStatus() {
    if (!state.userInfo) {
      return Promise.resolve(state.checkInStatus)
    }
    
    try {
      const response = await axios.get(apiConfig.member.checkInStatus, {
        params: {
          memberId: state.userInfo.id
        }
      })
      
      if (response.data.code === 200) {
        const checkInStatus = response.data.data
        mutations.setCheckInStatus(checkInStatus)
        return checkInStatus
      } else {
        console.error('获取签到状态失败:', response.data.message)
        return state.checkInStatus
      }
    } catch (error) {
      console.error('获取签到状态请求失败:', error)
      return state.checkInStatus
    }
  },
  addPoints(amount) {
    // 添加积分
    mutations.updatePoints(amount)
    return Promise.resolve(true)
  },
  checkPaymentStatus(orderId) {
    // 模拟查询支付状态
    // 在实际项目中，这里应该调用后端API查询支付状态
    return new Promise((resolve) => {
      setTimeout(() => {
        // 模拟支付成功
        resolve({ success: true, orderId })
      }, 1000)
    })
  },
  async createPaymentOrder(amount, subject, body) {
    try {
      const orderNo = 'ORDER_' + Date.now()
      const response = await axios.post(apiConfig.payment.create, {
        orderNo: orderNo,
        amount: amount,
        subject: subject,
        body: body
      })
      
      if (response.data.code === 200) {
        return { success: true, qrCode: response.data.data, orderNo: orderNo }
      } else {
        console.error('创建支付订单失败:', response.data.message)
        return { success: false, message: response.data.message }
      }
    } catch (error) {
      console.error('创建支付订单请求失败:', error)
      return { success: false, message: '创建支付订单请求失败' }
    }
  }
}

export default {
  state: readonly(state),
  mutations,
  actions
}
